import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import inputText from './inputText.js'
import reset from './reset.js'
import select from './select.js'
import wrapper from './wrapper.js'

export default contract({
  inputText: array([
    inputText
  ]),
  reset: array([
    reset
  ]),
  select: array([
    select
  ]),
  wrapper: array([
    wrapper
  ])
})